import React, { Component } from 'react';
import config from 'config';
import TermsAndConditions from '../TermsAndConditions';
import InstantConfirmation from './commons/InstantConfirmation';
import OnDemandDisclaimer from './commons/OnDemandDisclaimer';
import builder from './builder';
import { hook } from 'app/utils/hook';
import { PROVIDER_DISCLAIMER_HOOK } from 'app/constants';
import messages from '../messages.intl';

import style from './style.css';

class ConfirmBooking extends Component {
  render() {
    const { onDemand, areTermsInternal, termsOfServiceURL } = this.props;

    return (
      <div className={style.confirm}>
        {onDemand && <OnDemandDisclaimer />}
        <InstantConfirmation />
        {!config.SHOW_AGREE_WITH_TERMS_CHECKBOX && (
          <TermsAndConditions
            prefixMessage={messages.BY_CLICKING_TERMS}
            termsOfServiceURL={termsOfServiceURL}
            areTermsInternal={areTermsInternal}
          />
        )}
        {hook({
          name: PROVIDER_DISCLAIMER_HOOK,
          defaultHandler: () => null,
        })}
      </div>
    );
  }
}

// TODO: move to Flow types
// ConfirmBooking.propTypes = {
//   onDemand: PropTypes.bool,
//   areTermsInternal: PropTypes.bool,
//   termsOfServiceURL: PropTypes.string,
//   price: PropTypes.string
// };

export default builder(ConfirmBooking);
